// components/auth/ForgotPassword.tsx
import { Button, Group, Stack, TextInput } from "@mantine/core";

interface ForgotPasswordProps {
  email: string;
  setEmail: (email: string) => void;
  onSubmit: () => void;
  onBack: () => void;
}

export default function ForgotPassword({
  email,
  setEmail,
  onSubmit,
  onBack,
}: ForgotPasswordProps) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        // clear the form
        setEmail("");
        // call the onSubmit function passed as a prop
        onSubmit();
      }}
    >
      <Stack>
        <TextInput
          label="Email address"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)}
          required
        />
        <Group justify="space-between" mt="md">
          <Button variant="default" onClick={onBack}>
            Back to login
          </Button>
          <Button type="submit">Send reset link</Button>
        </Group>
      </Stack>
    </form>
  );
}
